import dayjs from 'dayjs';

export default function secondsToCountdown(remainingSeconds: number): string {
  const endsIn = dayjs.duration(remainingSeconds, 'second');
  const days = endsIn.get('days');
  const hours = endsIn.get('hours');
  const minutes = endsIn.get('minutes');
  const seconds = endsIn.get('seconds');
  const d = days > 0 ? `${days}d ` : '';
  const h = hours > 0 ? `${hours.toString().padStart(2, '0')}h ` : '';
  const m = minutes > 0 ? `${minutes.toString().padStart(2, '0')}m ` : '';
  const s = `${seconds.toString().padStart(2, '0')}s`;

  return `${d}${h}${m}${s}`;
}
